export default {
  http: {
    request: '请求错误',
    repetition: '重复请求',
    timeout: '请求超时',
    err: '链接服务器失败!'
  },
}
